// extracted by mini-css-extract-plugin
module.exports = {"shell":"Shell_shell__1EFPR","main":"Shell_main__2ypHl","splitPaneContainer":"Shell_splitPaneContainer__3ClHv"};